import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

export const IPShell = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const IPHubTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  fontFamily: theme.typography.fontFamily,
})) as typeof Text;
